import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICardContent } from 'shared/models';
import { GridComponent, CardSliderComponent } from '@sirius/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'commerce-marketplace-categories',
    templateUrl: './marketplace-categories.component.html',
    styleUrl: './marketplace-categories.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, CardSliderComponent, TranslatePipe]
})
export class MarketplaceCategoriesComponent {
    @Input({ required: true })
    categories: ICardContent[] = [];

    @Input()
    selectedCategory?: string;
}
